import { Brand } from '../brand/brand.model';
import { Channel } from '../channel/channel.model';
import { Dealer } from '../dealer/dealer.model';
import { User } from '../user/user.model';
import { Lead } from './lead';

export class LeadByidResponse {
  lead: Lead;

  constructor(lead: Lead) {
    this.lead = lead;
  }

  getLead(): Lead {
    const leadObject = new Lead();
    leadObject.id = this.lead.id;
    leadObject.status = this.lead.status;
    leadObject.onTrack = this.lead.onTrack;
    leadObject.contactName = this.lead.contactName;
    leadObject.contactPhone = this.lead.contactPhone;
    leadObject.contactEmail = this.lead.contactEmail;
    leadObject.vat = this.lead.vat;
    leadObject.emailSubject = this.lead.emailSubject;
    leadObject.type = this.lead.type;
    leadObject.descriptionModel = this.lead.descriptionModel;
    leadObject.comments = this.lead.comments;
    leadObject.origin = this.lead.origin;
    leadObject.transferred = this.lead.transferred;
    leadObject.assignedDate = this.lead.assignedDate;
    leadObject.firstCallDate = this.lead.firstCallDate;
    leadObject.firstContactDate = this.lead.firstContactDate;
    leadObject.firstInteractionDate = this.lead.firstInteractionDate;
    leadObject.callStartTime = this.lead.callStartTime;
    leadObject.visitDate = this.lead.visitDate;
    leadObject.reminderDate = this.lead.reminderDate;
    leadObject.createdAt = this.lead.createdAt;
    leadObject.updatedAt = this.lead.updatedAt;
    leadObject.inCall = this.lead.inCall;
    leadObject.hasHtml = this.lead.hasHtml;
    leadObject.tags = this.lead.tags;
    leadObject.user = this.lead.user || new User();
    leadObject.brand = this.lead.brand || new Brand();
    leadObject.channel = this.lead.channel || new Channel();
    leadObject.dealer = this.lead.dealer || new Dealer();
    leadObject.hasMessageId = this.lead.hasMessageId;
    leadObject.postalCode = this.lead.postalCode;
    leadObject.location = this.lead.location;
    leadObject.address = this.lead.address;
    leadObject.prequalification = this.lead.prequalification;
    leadObject.scoring = this.lead.scoring;
    leadObject.sentToAutonet = this.lead.sentToAutonet;
    leadObject.plate = this.lead.plate;
    return leadObject;
  }

  getLeadFromObject(data: any): Lead {
    const leadObject = new Lead();
    leadObject.id = data.id;
    leadObject.status = data.status;
    leadObject.onTrack = data.onTrack;
    leadObject.contactName = data.contactName;
    leadObject.contactPhone = data.contactPhone;
    leadObject.contactEmail = data.contactEmail;
    leadObject.vat = data.vat;  
    leadObject.type = data.type;
    leadObject.descriptionModel = data.descriptionModel;
    leadObject.comments = data.comments;
    leadObject.origin = data.origin;
    leadObject.transferred = data.transferred;
    leadObject.assignedDate = data.assignedDate;
    leadObject.firstCallDate = data.firstCallDate;
    leadObject.firstContactDate = data.firstContactDate;
    leadObject.firstInteractionDate = data.firstInteractionDate;
    leadObject.callStartTime = data.callStartTime;
    leadObject.visitDate = data.visitDate;
    leadObject.reminderDate = data.reminderDate;
    leadObject.createdAt = data.createdAt;
    leadObject.updatedAt = data.updatedAt;
    leadObject.inCall = data.inCall;
    leadObject.hasHtml = data.hasHtml;
    leadObject.tags = data.tags;
    leadObject.user = data.user || new User();
    leadObject.brand = data.brand || new Brand();
    leadObject.channel = data.channel || new Channel();
    leadObject.dealer = data.dealer || new Dealer();
    leadObject.postalCode = data.postalCode;
    leadObject.location = data.location;
    leadObject.address = data.address;
    return leadObject;
  }
}
